// Etiqueta de servicio de un activo CMMS (como la de su sistema anterior):
// QR · "ETIQUETA DE SERVICIO" · No. Serie · Ing. asignado · Último / Próximo Mprev ·
// Folio de última OS preventiva · Proveedor de servicio · logo.
//
// formato "etiqueta": una etiqueta por hoja de 100 x 38 mm (impresora de etiquetas).
// formato "carta":    hoja carta con 2 columnas x 7 renglones (para recortar).
// datos: respuesta de cmms/datosEtiquetasActivosCMMS. urlActivo(token) arma la URL del QR.

const mm = (v) => v * 2.83465;

// pdfmake corta mal palabras largas sin espacios: se les intercalan espacios de ancho cero.
const partible = (t) => String(t || "").replace(/(\S{14})/g, "$1​");

const fecha = (f) => {
    if (!f) return "—";
    const d = new Date(f);
    return isNaN(d.getTime()) ? "—" : d.toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" });
};

const renglon = (etiqueta, valor) => ({
    text: [{ text: `${etiqueta}: `, bold: true }, { text: partible(valor || "—") }],
    margin: [0, 0, 0, 1.2],
});

const contenidoEtiqueta = (a, datos, urlActivo, ancho, alto) => {
    const qr = Math.min(alto - mm(6), mm(30));
    const logo = datos.logos?.[a.logo];
    const anchoLogo = logo ? mm(16) : 0;
    return {
        table: {
            widths: [qr + 4, "*", anchoLogo],
            heights: [alto - mm(4)],
            body: [
                [
                    { qr: urlActivo(a.tokenPublico), fit: qr, margin: [0, 2, 0, 0] },
                    {
                        // Compacto: debe caber en 38 mm de alto sin brincar de hoja.
                        stack: [
                            {
                                columns: [
                                    { text: "ETIQUETA DE SERVICIO", fontSize: 7, color: "#444444", width: "*" },
                                    { text: a.codigo || "", fontSize: 5.5, color: "#888888", width: "auto", margin: [0, 1, 0, 0] },
                                ],
                                margin: [0, 0, 0, 1.5],
                            },
                            renglon("No. Serie", a.numeroSerie),
                            renglon("Equipo", [a.tipo, a.marca, a.modelo].filter(Boolean).join(" · ")),
                            renglon("Ing. Asignado", a.ingeniero),
                            {
                                text: [{ text: "Último Mprev: ", bold: true }, fecha(a.ultimoPreventivo), { text: "   Próximo: ", bold: true }, fecha(a.proximoPreventivo)],
                                margin: [0, 0, 0, 1.2],
                            },
                            renglon("Última OS preventiva", a.folioUltimoPreventivo),
                            { ...renglon("Proveedor de Servicio", datos.proveedorServicio), fontSize: 5.6 },
                        ],
                        fontSize: 6.2,
                    },
                    logo ? { image: logo, fit: [anchoLogo, alto - mm(8)], alignment: "center", margin: [0, mm(2), 0, 0] } : { text: "" },
                ],
            ],
        },
        layout: "noBorders",
        width: ancho,
    };
};

const etiquetaActivoCMMSPdf = (datos, { formato = "etiqueta", urlActivo }) => {
    const activos = datos.activos || [];
    if (!activos.length) throw new Error("No hay activos para imprimir");

    if (formato === "carta") {
        // 2 columnas x 7 renglones en carta, con margen para recortar.
        const ancho = mm(100);
        const alto = mm(36);
        const filas = [];
        for (let i = 0; i < activos.length; i += 2) {
            filas.push([
                { stack: [contenidoEtiqueta(activos[i], datos, urlActivo, ancho, alto)], margin: [mm(1.5), mm(1.5), mm(1.5), mm(1.5)] },
                activos[i + 1]
                    ? { stack: [contenidoEtiqueta(activos[i + 1], datos, urlActivo, ancho, alto)], margin: [mm(1.5), mm(1.5), mm(1.5), mm(1.5)] }
                    : { text: "" },
            ]);
        }
        return {
            pageSize: "LETTER",
            pageMargins: [mm(4), mm(8), mm(4), mm(8)],
            content: [
                {
                    table: { widths: ["50%", "50%"], heights: alto + mm(3), dontBreakRows: true, body: filas },
                    layout: {
                        hLineWidth: () => 0.4,
                        vLineWidth: () => 0.4,
                        hLineColor: () => "#cccccc",
                        vLineColor: () => "#cccccc",
                        hLineStyle: () => ({ dash: { length: 2 } }),
                        vLineStyle: () => ({ dash: { length: 2 } }),
                    },
                },
            ],
            defaultStyle: { fontSize: 7 },
        };
    }

    const ancho = mm(100);
    const alto = mm(38);
    const content = [];
    activos.forEach((a, i) => {
        if (i > 0) content.push({ text: "", pageBreak: "before" });
        content.push(contenidoEtiqueta(a, datos, urlActivo, ancho - mm(4), alto));
    });
    return {
        pageSize: { width: ancho, height: alto },
        pageMargins: [mm(2), mm(2), mm(2), mm(1)],
        content,
        defaultStyle: { fontSize: 7 },
    };
};

export default etiquetaActivoCMMSPdf;
